import { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import {MESSAGE_RECEIVED} from '../../../data/messageTypes';

class MessageSender extends Component {
  label() {
    const {type} = this.props;

    return type === MESSAGE_RECEIVED ? 'From' : 'To';
  }

  name() {
    const {type, message} = this.props;

    return type === MESSAGE_RECEIVED ? message.attributes.from : message.attributes.to;
  }

  render() {
    return (
      <Row className="sender">
        <Col lg={12}>
          {this.label()}: {this.name()}
        </Col>
      </Row>
    );
  }
}

export default MessageSender;
